import { useEffect, useState } from "react";
import IGlobalConfig from "../../../../../../types/IGlobalConfig";
import ICharityEmailSetup from "../../../../../../types/ICharityEmailSetup";
import { getDnsDelegateStatus } from "../../../../../../utils/dnsDelegateApi";

interface UseDnsDelegateDeliveryStatusProps {
  charityId?: string;
  config?: IGlobalConfig;
  serviceAccessToken?: string;
  emailSetup: ICharityEmailSetup | null;
  emailSetupLoaded: boolean;
}

export interface DnsDelegateDeliveryStatus {
  deliveryFailed: boolean;
  isLoaded: boolean;
}

export function useDnsDelegateDeliveryStatus({
  charityId,
  config,
  serviceAccessToken,
  emailSetup,
  emailSetupLoaded,
}: UseDnsDelegateDeliveryStatusProps): DnsDelegateDeliveryStatus {
  const [deliveryFailed, setDeliveryFailed] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const shouldFetch =
    emailSetupLoaded &&
    !emailSetup?.sendingEmailsConfigured &&
    Boolean(charityId) &&
    Boolean(config?.adminServiceUrl) &&
    Boolean(serviceAccessToken);

  useEffect(() => {
    if (!shouldFetch) {
      setDeliveryFailed(false);
      setIsLoaded(emailSetupLoaded);
      return;
    }

    let cancelled = false;

    getDnsDelegateStatus(config!.adminServiceUrl!, charityId!, serviceAccessToken!)
      .then(status => {
        if (!cancelled) {
          setDeliveryFailed(Boolean(status.deliveryFailed && status.lastSentEmail));
          setIsLoaded(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setDeliveryFailed(false);
          setIsLoaded(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [
    shouldFetch,
    charityId,
    config?.adminServiceUrl,
    serviceAccessToken,
    emailSetup?.sendingEmailsConfigured,
    emailSetupLoaded,
  ]);

  return { deliveryFailed, isLoaded };
}
